define('views/ContactView',[
    'backbone',
    'lodash',
    'text!templates/contact.html',
    'app'
], function (Backbone, _, contactTmpl, App) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        template: _.template(contactTmpl),

        render: function () {
            this.$el.html(this.template(App));
        }

    });

});
